import React from 'react'

const Social = () => {
  return (
    <div className="home-social">
      <a href="https://www.linkedin.com/in/sudeshna-pandey-a2024b188/" className="home-social-icon" target='_blank' rel='noopener noreferrer'><i className="uil uil-linkedin-alt"></i></a>
      <a href="https://github.com/sudeshna-22" className="home-social-icon" target='_blank' rel='noopener noreferrer'><i className="uil uil-github-alt"></i></a>
      <a href="https://www.instagram.com/sudeshna_ev/" className="home-social-icon" target='_blank' rel='noopener noreferrer'><i className="uil uil-instagram"></i></a>
      <a href="https://www.facebook.com/shrutii3101/" className="home-social-icon" target='_blank' rel='noopener noreferrer'><i className="uil uil-facebook"></i></a>
    </div>
  )
}

export default Social